import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: ${props => props.theme.shade[90]};
  z-index: 1;
  display: grid;
  gap: 32px;
  flex-wrap: wrap;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  pointer-events: ${props => (props.isOpen ? "all" : "none")};
  transition: 0.4s;
  p {
    margin: 0;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    display: none;
  }
`
const CustomLink = styled(Link)`
  color: ${props => props.theme.shade[0]};
  text-align: center;
  text-decoration: none;
  font-size: 2rem;
  font-weight: 800;
`
const NavLinks = styled.div`
  margin: auto 0;
  padding: 0 32px;
  display: grid;
  grid-auto-flow: row;
  justify-content: center;
  align-items: center;
`

export default function Menu({ isOpen }) {
  return (
    <Container isOpen={isOpen}>
      <NavLinks>
        <CustomLink activeClassName="active" to="/">
          Home
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/our-user-testing/"
        >
          Our user testing
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/how-we-do-it/"
        >
          How we do it
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/about/"
        >
          About
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/innovation-lab/"
        >
          Innovation Lab
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/contact/"
        >
          Contact
        </CustomLink>
      </NavLinks>
    </Container>
  )
}
